<template>
  <main class="roles-page">
    <HeroSection :page="page" />
    <LogoSection />
    <RoleDescriptionSection
      ref="contentSection"
      :page="page"
    />
    <WhyProxify />
    <HowItWorksSection />
    <div :class="{ container: !isTablet }">
      <SearchSection
        class="search-section"
        search-title="Search more roles"
      />
    </div>
    <SubscribeSection />
    <OurReachSection />
    <FaqSection />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import LogoSection from './LogoSection/LogoSection.vue';
import RoleDescriptionSection from './RoleDescriptionSection/RoleDescriptionSection.vue';
import WhyProxify from './WhatWeOfferSection/WhyProxify.vue';
import HowItWorksSection from './HowItWorksSection/HowItWorksSection.vue';
import SearchSection from '~/components/Common/SearchSection/SearchSection.vue';
import SubscribeSection from '~/components/Common/SubscribeSection/SubscribeSection.vue';
import OurReachSection from '~/components/Common/OurReachSection/OurReachSection.vue';
import FaqSection from '~/components/Common/FaqSection/FaqSection.vue';
import isTablet from '~/mixins/responsive';

export default {
  components: {
    HeroSection,
    LogoSection,
    RoleDescriptionSection,
    WhyProxify,
    HowItWorksSection,
    SearchSection,
    SubscribeSection,
    OurReachSection,
    FaqSection,
  },
  mixins: [isTablet],
  props: {
    page: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import './RolePage.scss';
</style>
